import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../environments/environment.prod";
import { AbstractService } from "../../../../services/abstract.service";
import OrderPaymentAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity";
const apiUrl = env.API_AVE_INTEGRATOR_URL;
const moduleName = "order_payment";

@Injectable({
  providedIn: "root",
})
export class OrderPaymentIntegratosServicesService extends AbstractService<OrderPaymentAttributes,any,any> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  sincronize(serials): Observable<any>{
    const API_URL: string = apiUrl + `api/${moduleName}`;
    return this.http.post<any>(API_URL, serials);
  }
}
